import type { MibStatus } from "./api.js";

const WORDS: Record<MibStatus, string> = { ok: "OK", warnings: "WARN", broken: "BROKEN" };
const WIDTH = Math.max(...Object.values(WORDS).map((w) => w.length));

/**
 * "[ OK     ]", padded so every status is the same width and the column
 * lines up. Rendered with white-space: pre -- without it the padding
 * collapses, which has shipped twice in this codebase.
 */
export function mibStatusLabel(status: MibStatus): string {
  return `[ ${WORDS[status].padEnd(WIDTH)} ]`;
}

export const MIB_STATUS_COLOR: Record<MibStatus, string> = {
  ok: "var(--status-good)",
  warnings: "var(--status-warning)",
  broken: "var(--status-critical)",
};
